(() => {
  'use strict';
  if (customElements.get('trc-premade-preview')) return;
  const requests = new Map();
  const MAX_BYTES = 2 * 1024 * 1024;
  const MAX_CARDS = 612;
  // Pinned premade deck XML: the order-export Worker on the tracker domain. Snapshot URLs the Worker
  // returns (and Studio saved) may name its workers.dev address; both are read from SNAPSHOT_HOST.
  const SNAPSHOT_HOST = 'https://track.tablereadycards.com';
  const SNAPSHOT_ORIGINS = [SNAPSHOT_HOST, 'https://order-export.evponix.workers.dev'];
  // TRC's own backs as Google Drive files, oldest first: the brown print back, and the white logo/QR image
  // (a separate info-card back). A new upload of a back adds its id here; earlier ids stay (saved XML
  // files name them). Studio's own markers show the newest upload.
  const STANDARD_BACK_DRIVE_IDS = ['19d4vZZFHNC1LMe04z7CBLmygv9U-_bJZ', '1Knmcv9YDYQE0uihaWZV0xTIshcZGfKeA'];
  const INFO_BACK_DRIVE_IDS = ['1StN4IQV-Kdat2TE43JHGaD-VZoGuz6VO', '1wVxthaH2sAlD2RZkdO_uW2TUKCZWPKe-'];
  const DEFAULT_BACK = STANDARD_BACK_DRIVE_IDS[STANDARD_BACK_DRIVE_IDS.length - 1];
  const INFO_CARD_BACK = INFO_BACK_DRIVE_IDS[INFO_BACK_DRIVE_IDS.length - 1];
  const TRC_BACK_IDS = [...STANDARD_BACK_DRIVE_IDS, ...INFO_BACK_DRIVE_IDS, 'trc:default-cardback'];
  const VERSION_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  // MPC Fill art (a Google Drive file id) shows TRC's own copy from the upload Worker, which fetches it
  // from Drive once; the browser never loads Drive. A copy that is busy or not ready yet fails like a
  // missing one: its tile shows the card's name and asks again after each delay.
  const DRIVE_ID = /^[A-Za-z0-9_-]{20,100}$/;
  const XML_THUMBNAIL_BASE = 'https://uploads.tablereadycards.com/xml-thumbnails/v1/';
  const XML_THUMBNAIL_RETRY_MS = [20000, 65000];
  // At most this many of those copies load at once, so a large file never asks for every card together.
  // A copy that neither loads nor fails within XML_THUMBNAIL_TURN_MS (an offscreen lazy image, a slow
  // answer) gives its turn to the next one and keeps loading.
  const MAX_XML_THUMBNAIL_LOADS = 6;
  const XML_THUMBNAIL_TURN_MS = 10000;
  function xmlThumbnailUrl(id, attempt) {
    return `${XML_THUMBNAIL_BASE}${id}.jpg${attempt ? `?retry=${attempt}` : ''}`;
  }
  function isXmlThumbnail(url) {
    return typeof url === 'string' && url.startsWith(XML_THUMBNAIL_BASE);
  }
  // AbortSignal.timeout (iOS 16+) and Object.hasOwn (iOS 15.4+) are avoided so
  // premade previews keep working on older iPhones.
  function timeoutSignal(milliseconds) {
    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') return AbortSignal.timeout(milliseconds);
    if (typeof AbortController !== 'function') return undefined;
    const controller = new AbortController();
    setTimeout(() => controller.abort(), milliseconds);
    return controller.signal;
  }
  // Exact-art recovery cache. Entries are tied to the saved source revision;
  // uploading a new XML with a different artwork date never reuses stale art.
  const recoveredThumbnails = {
    "111KRzNBP4dB2S1mvTKZB18TbaFMwQNSa": {
      "modified": "",
      "sha256": "86f733d0c19236c29c89f35b65a7eb6eaf66b5958626422b131b2c7dd078eda5"
    },
    "11pN3ngp_afG0Idr52kJix4Cg-QP9J4a5": {
      "modified": "10th September, 2023",
      "sha256": "4b87d4832105760443d518326b4acfbf1c44555ba58e7bc0ccb160c3d93b996a"
    },
    "147Vu5WV6Xx8ZIsLAVwGKriep-zOHlZMe": {
      "modified": "",
      "sha256": "c8e49f96590e6b44f8827f98b3015ee73e73bc5b5a2801593baf357831be2936"
    },
    "1BERxIjvFWZRVj1YokELKn2ZPrl3n0v43": {
      "modified": "14th July, 2020",
      "sha256": "f246cd4a6a4b5fed899115877749fb48f93787d85be2772f13a881897801b11f"
    },
    "1CCzEgxzZuAKdPJZFULbBuFwYRLVGBtIj": {
      "modified": "27th December, 2023",
      "sha256": "6ed72823ee932babe231ca2ac7bdf2c575ae6d38fd965aabf7fd434f4ae89834"
    },
    "1EcOueZe9MDJQSjCx6GJt1tZAC8PdJ3qX": {
      "modified": "13th July, 2020",
      "sha256": "745f9e7cc39b37c5221c5f327b5dd534f8577405d9cdea9dd4e8b408db50171e"
    },
    "1eUz-c0zShlNgCwOmMzUnxRf2v_HvEl22": {
      "modified": "14th July, 2020",
      "sha256": "450dcb3038ef40d8659b56ac8878f70b4276674de261518edd04c091d3e6aae7"
    },
    "1eZbpkYZl7dGcw5T8KRuYfHGEzbuZN52W": {
      "modified": "10th September, 2023",
      "sha256": "e8d0b617ddb95d0944f5f4c73c77cde29cbd7a77c67ad9fc8806048462b42fe5"
    },
    "1FinJhIYsXnnlTWhm3A97tnxeBdNpdELO": {
      "modified": "",
      "sha256": "50e4d13b58237c066df95b6818f6aa38c4cc0eefbe689a3795f1112de42bd1ef"
    },
    "1fIZ680enu58GYweMziuqNNVTQ4ABIQnm": {
      "modified": "13th July, 2020",
      "sha256": "3fa046af2a4a55761a7324671c1b03eab3171340d250059c1df220ec00cf68fa"
    },
    "1GjHgpPBUDW0sdUQ_BX0nvQyz6lPM2fs7": {
      "modified": "13th July, 2020",
      "sha256": "e76a3688d9442afb674e4ef59678e64ca031f0b036d02bd31d59a25d561ba3be"
    },
    "1hDB7iYQW5u3x-hDPxhLBh0xfhsurEa2m": {
      "modified": "20th November, 2022",
      "sha256": "088e2890448c576e3ba0b598efa40f2c242f3d408ab2ec1196faf53aa1f10b24"
    },
    "1hRVYfMPJGVKXKcZNgUEHPn0U1YZTfC9N": {
      "modified": "24th April, 2026",
      "sha256": "dd70f33ff80c66bfc49718c469222fc560fb8924eab92e6ffd0a96843b544d3e"
    },
    "1HwBNDwbdz7h5B0-wpL1_ERmqqFZQwMcC": {
      "modified": "4th August, 2020",
      "sha256": "7143251592bc681b452b9438ce5c85e52359c537358353759fbc016277e4c4cc"
    },
    "1hWhNSqaK4RnpAyQunvf4UqEtUEqUNsWj": {
      "modified": "",
      "sha256": "b6ecc2efaf179aa3a463c945dd8a53721a7b050f7ea8fab4c911d6233f4eabec"
    },
    "1mN2-LS4HURyQQcTp2_WMCi76dsBmLuXL": {
      "modified": "15th July, 2020",
      "sha256": "989452a1dc56e77ac048c6370f3ee17acfa0cf7be40584f46e6c888aa7dfe84c"
    },
    "1p-vs8qd5rB2Qbw3a0xTwFNGesXeH6u7r": {
      "modified": "",
      "sha256": "329ace22066022daadfd2ac6a43b0da803ad388ecf45851e64144ecb5859a543"
    },
    "1Qwg5EwVoALouWAJDJPTA09ZPOY4PXcCz": {
      "modified": "29th July, 2020",
      "sha256": "cfb1f0f7c0ef55eef80134d4c9212a62851527bd028dd8ef1e944f34214c4856"
    },
    "1RRMurHKqV7vxVZZAStJ2QE3KY-y0II4j": {
      "modified": "21st July, 2024",
      "sha256": "bb88766d9c0498184dc29e13840b054973094be477ea7276353ca1e9bba0505d"
    },
    "1t_IZSAi5x_QxrnDzIt9tFyCkW531ZG8U": {
      "modified": "",
      "sha256": "54cf28b9aef740198512b0110db68f07d50d933f64ced78c3ff6c76be78c6dba"
    },
    "1tKmk-CZllehoiVqlYt4R2WC1PGQU-0Pd": {
      "modified": "25th July, 2024",
      "sha256": "4f555fdf77b583df4492265007650ab160ee2ea68e666e61a0982d8a819f25ff"
    },
    "1UIN_FSyUWCf4q5TkR8SfT_t0SYA1AZ9e": {
      "modified": "29th September, 2024",
      "sha256": "ca882b7a18b662fee50fb8c8334ba2c38990f11582f28571dbbe37538a081589"
    },
    "1X2fR_JHK2p_IV1-GLU-XrUqqM16AXm9M": {
      "modified": "",
      "sha256": "a1c2fe1be10787b2b8758c7da974a05ae0d94a5c0caa11f8e867e1c2292feed5"
    },
    "1XPZ9MnYB5oBlkCdlxJHPy37iV030BRLO": {
      "modified": "",
      "sha256": "61df0f33f0e2071ad3e423640550c269324a4dab5d8f33fe71adfff7faed664b"
    },
    "1yeXGFk4OBjzEi5fxJrv5UNZnc0yh5PIP": {
      "modified": "23rd October, 2022",
      "sha256": "70918618d0e7f798b8a3cee47d317093f1956d8002b0bb208fd4ab1696864294"
    }
  };
  const text = (node, tag) => node.querySelector(`:scope > ${tag}`)?.textContent.trim() || '';
  // Fireball Foil prints on card fronts only. Two-sided cards are slots with a back of their own, by the
  // same rule as the cart (assets/trc-deck-art.js xmlDeckCards): TRC's backs and Studio's generated preview
  // and info-card images are not per-card backs.
  const TRC_LOCAL_BACKS = [/^local:TRC[\s_]+Card[\s_]+Back[\s_]+4\.png$/i, /^local:TRC[\s_]+White[\s_]+Cardback\.png$/i];
  const GENERATED_LOCAL = [/^.+[\s_]+Deck[\s_]+Preview(?:[\s_]+(?:Standard|Spotlight)(?:_[A-Za-z0-9]+)?)?(?: \(\d+\))?\.png$/i, /^TRC[\s_]+White[\s_]+Cardback(?: \(\d+\))?\.png$/i];

  function generatedLocal(id, sourceType) {
    if (!id.startsWith('local:') && sourceType !== 'Local File') return false;
    const filename = id.startsWith('local:') ? id.slice(6) : id;
    return !/[\\/\r\n]/.test(filename) && GENERATED_LOCAL.some(pattern => pattern.test(filename));
  }

  // The flip glyph (two curved arrows in a loop) of the cart and tracker deck popups.
  const FLIP_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 11a8 8 0 0 0-14.5-4.6L4 8"/><path d="M4 3v5h5"/><path d="M4 13a8 8 0 0 0 14.5 4.6L20 16"/><path d="M20 21v-5h-5"/></svg>';

  function foilNoteText(count) {
    return 'Foil prints on card fronts only.' + (count === 1
      ? ' This deck has 1 two-sided card, so its back prints without foil.'
      : count > 1 ? ` This deck has ${count} two-sided cards, so their backs print without foil.` : '');
  }

  // The visible "Two-sided cards" line property (never "Print Type" or "Foiling").
  function twoSidedValue(count) {
    return count === 1 ? '1 (back prints without foil)' : count > 1 ? `${count} (backs print without foil)` : '';
  }

  function projectReferences(root) {
    try {
      const references = JSON.parse(text(root, 'trcProject')).references;
      return references && typeof references === 'object' && !Array.isArray(references) ? references : {};
    } catch (_) {
      // Optional Studio metadata must not break older MPC Fill XMLs.
      return {};
    }
  }

  // First-party thumbnails for a saved premade version (order-export Worker):
  // active.thumbnailsUrl names a JSON map of Drive id to one of our own image
  // URLs. With it, a card without a usable entry shows a named placeholder.
  // Without it (an older Worker), Drive ids show the upload Worker's copy.
  const THUMBNAIL_PATH = /^\/premade-decklists\/thumbnails\/(\d+)\/([A-Za-z0-9_-]{1,200})\.json$/;
  const FIRST_PARTY_THUMBNAIL = [
    /^https:\/\/track\.tablereadycards\.com\/image-library\/versions\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/thumbnail$/i,
    /^https:\/\/decklists\.tablereadycards\.com\/(?:profile|premade)-thumbnails\/v1\/[0-9a-f]{64}\.(?:jpg|png)$/i
  ];
  // Tiles wait at most THUMBNAIL_WAIT_MS for the map (the XML alone can show
  // them); a later map still upgrades them. An unfinished map (the Worker sends
  // it with max-age 60 while incomplete) is asked for once more, past that
  // cache lifetime and with no-store, so the retry can see new thumbnails.
  const THUMBNAIL_WAIT_MS = 3000;
  const THUMBNAIL_RETRY_MS = 65000;
  function firstPartyThumbnail(value) {
    return typeof value === 'string' && FIRST_PARTY_THUMBNAIL.some(pattern => pattern.test(value)) ? value : '';
  }
  // The thumbnail map, or an empty incomplete one on any failure (a pending
  // revision answers 409).
  async function loadThumbnails(rawUrl, variantId, revision, fresh) {
    const empty = { thumbnails: {}, complete: false };
    try {
      const url = new URL(rawUrl);
      const match = THUMBNAIL_PATH.exec(url.pathname);
      if (url.origin !== SNAPSHOT_HOST || url.username || url.password || url.search || url.hash || !match || match[1] !== String(variantId) || match[2] !== revision) return empty;
      const response = await fetch(url.href, { credentials: 'omit', signal: timeoutSignal(15000), ...(fresh ? { cache: 'no-store' } : {}) });
      if (!response.ok) return empty;
      const body = await response.json();
      if (!body || body.ok !== true || String(body.variantId) !== String(variantId) || body.revision !== revision || !body.thumbnails || typeof body.thumbnails !== 'object' || Array.isArray(body.thumbnails)) return empty;
      return { thumbnails: body.thumbnails, complete: body.complete === true };
    } catch (_) {
      return empty;
    }
  }
  // A card's faces as the thumbnail map allows: our own image, or a placeholder.
  function withThumbnails(card, thumbnails) {
    if (!card.driveId) return card;
    const mapped = Object.prototype.hasOwnProperty.call(thumbnails, card.driveId) ? firstPartyThumbnail(thumbnails[card.driveId]) : '';
    if (card.firstParty) return { ...card, fallbackUrl: mapped };
    return { ...card, url: mapped, fallbackUrl: '', placeholder: !mapped };
  }

  function previewReference(id, sourceType, references, localOnly) {
    const original = imageReference(id, sourceType);
    // Scryfall's normal scans have no print bleed. Keep their uncropped image
    // path rather than using a cloud full-print thumbnail with different bleed.
    if (!original || original.scryfall || localOnly) return original;
    const saved = Object.prototype.hasOwnProperty.call(references, id) ? references[id] : null;
    if (!saved || saved.identifier !== id) return original;
    if (typeof saved._cloudVersionId === 'string' && VERSION_ID.test(saved._cloudVersionId)) {
      // The public image-library thumbnail on the order tracker's domain (as the cart's TRCDeckArt.LIBRARY_ORIGIN).
      return { ...original, url: `https://track.tablereadycards.com/image-library/versions/${saved._cloudVersionId.toLowerCase()}/thumbnail`, fallbackUrl: original.url, firstParty: true };
    }
    const cached = Object.prototype.hasOwnProperty.call(recoveredThumbnails, id) ? recoveredThumbnails[id] : null;
    if (cached && cached.modified === (saved.dateModified || saved.dateCreated || '')) {
      return { ...original, url: `https://decklists.tablereadycards.com/premade-thumbnails/v1/${cached.sha256}.jpg`, fallbackUrl: original.url, firstParty: true };
    }
    return original;
  }

  function imageReference(id, sourceType) {
    if (sourceType === 'Local File' && !id.startsWith('local:')) return null;
    const scry = /^scry:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(front|back)$/i.exec(id);
    if (scry) {
      const uuid = scry[1].toLowerCase();
      return { url: `https://cards.scryfall.io/normal/${scry[2].toLowerCase()}/${uuid[0]}/${uuid[1]}/${uuid}.jpg`, scryfall: true };
    }
    if (id === 'trc:default-cardback' || id.toLowerCase() === 'local:trc card back 4.png') id = DEFAULT_BACK;
    if (id.toLowerCase() === 'local:trc white cardback.png') id = INFO_CARD_BACK;
    // Drive ids keep their id (driveId) so a thumbnail map can replace this URL.
    if (DRIVE_ID.test(id)) return { url: xmlThumbnailUrl(id), scryfall: false, driveId: id };
    return null;
  }

  function parse(xml, maxCards = MAX_CARDS) {
    if (new TextEncoder().encode(xml).length > MAX_BYTES || /<!DOCTYPE|<!ENTITY/i.test(xml)) throw new Error('Unsupported XML');
    const doc = new DOMParser().parseFromString(xml, 'application/xml');
    if (doc.querySelector('parsererror') || doc.documentElement.tagName !== 'order') throw new Error('Invalid deck XML');
    const root = doc.documentElement;
    const references = projectReferences(root);
    const read = (face) => {
      const slots = new Map();
      for (const node of root.querySelectorAll(`:scope > ${face} > card`)) {
        const id = text(node, 'id');
        const localOnly = id.startsWith('local:') || text(node, 'sourceType') === 'Local File';
        const name = (text(node, 'name') || text(node, 'query') || 'Card').replace(/\.(png|jpe?g|webp)$/i, '');
        const positions = text(node, 'slots').split(',');
        if (!id || positions.length > maxCards) throw new Error('Invalid artwork');
        for (const raw of positions) {
          if (!/^\d+$/.test(raw.trim())) throw new Error('Invalid slot');
          const slot = Number(raw);
          if (slot >= maxCards || slots.has(slot)) throw new Error('Duplicate or invalid slot');
          slots.set(slot, { id, name, localOnly, sourceType: text(node, 'sourceType'), ...previewReference(id, text(node, 'sourceType'), references, localOnly) });
        }
      }
      return slots;
    };
    const fronts = read('fronts');
    const backs = read('backs');
    if (!fronts.size || [...fronts.keys()].sort((a,b) => a-b).some((slot,index) => slot !== index)) throw new Error('Incomplete deck');
    const quantity = text(root.querySelector(':scope > details') || root, 'quantity');
    if (quantity && (!/^\d+$/.test(quantity) || Number(quantity) !== fronts.size)) throw new Error('Wrong card count');
    if ([...backs.keys()].some(slot => !fronts.has(slot))) throw new Error('Orphan back');
    const defaultBack = text(root, 'cardback');
    const studio = !!text(root, 'trcProject');
    const cards = [];
    let twoSided = 0;
    for (let slot = 0; slot < fronts.size; slot++) {
      cards.push({ ...fronts.get(slot), slot, back: false });
      const back = backs.get(slot);
      if (back && back.id !== defaultBack && !TRC_BACK_IDS.includes(back.id)) {
        cards.push({ ...back, slot, back: true });
        if (!TRC_LOCAL_BACKS.some(pattern => pattern.test(back.id)) && !(studio && generatedLocal(back.id, back.sourceType))) twoSided++;
      }
    }
    // Slots whose back prints without foil.
    cards.twoSided = twoSided;
    return cards;
  }

  async function load(rawUrl) {
    const url = new URL(rawUrl, location.href);
    const shopifyFile = ['cdn.shopify.com', location.hostname].includes(url.hostname) && /\/(files|cdn\/shop\/files)\//.test(url.pathname);
    const savedVersion = SNAPSHOT_ORIGINS.includes(url.origin) && /^\/premade-decklists\/snapshots\/\d+\/[A-Za-z0-9_-]{1,200}\.xml$/.test(url.pathname) && !url.search && !url.hash;
    if (url.protocol !== 'https:' || url.username || url.password || (!shopifyFile && !savedVersion)) throw new Error('Unsupported file URL');
    // U-7: a saved version is read from the Worker's own domain, whichever address names it.
    if (savedVersion) url.href = SNAPSHOT_HOST + url.pathname;
    if (!requests.has(url.href)) {
      const request = (async () => {
        const response = await fetch(url.href, { credentials: 'omit', signal: timeoutSignal(20000) });
        if (!response.ok || Number(response.headers.get('Content-Length')) > MAX_BYTES) throw new Error('Preview unavailable');
        const reader = response.body.getReader();
        const chunks = []; let length = 0;
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          length += value.byteLength;
          if (length > MAX_BYTES) { await reader.cancel(); throw new Error('XML too large'); }
          chunks.push(value);
        }
        return parse(await new Blob(chunks).text());
      })();
      requests.set(url.href, request);
      request.catch(() => requests.delete(url.href));
    }
    return requests.get(url.href);
  }

  class PremadePreview extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.generation = (this.generation || 0) + 1;
      this.clearThumbnailRetries();
      this.expanded = false;
      this.viewport = this.querySelector('[data-viewport]');
      this.grid = this.querySelector('[data-grid]');
      this.toggle = this.querySelector('[data-toggle]');
      this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
      this.legacyXmlUrl = this.dataset.xmlUrl || '';
      this.onVariant = () => {
        const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
        const id = form?.querySelector('[name=id]')?.value || this.dataset.variantId;
        const variant = this.variants.find(v => String(v.id) === String(id));
        this.dataset.foil = String(/fireball foil/i.test(variant?.title || ''));
        if (this.dataset.versionedPremade === 'true') {
          this.selectedVariantId = String(id);
          const version = window.TRCPremadeVersions?.getKnown(id);
          if (version) this.applyVersion(version);
          else if (this.versionVariantId !== String(id)) this.resetVersion();
        }
        this.syncFoil();
      };
      // Whatever form builds the cart request (the main form, or the sticky bar's own form whose variant can run
      // ahead of the main one), the property rides only on the Fireball Foil variant it was counted for.
      this.onFormData = event => {
        const form = event.target;
        if (!form || !event.formData || this.dataset.uploadInput) return;
        const main = form.id === `product-form-${this.dataset.sectionId}`;
        const sticky = !!this.dataset.productId && !!form.closest?.(`sticky-atc-bar[data-product-id="${this.dataset.productId}"]`);
        if (!main && !sticky) return;
        const id = String(event.formData.get('id'));
        const variant = this.variants.find(v => String(v.id) === id);
        const value = /fireball foil/i.test(variant?.title || '') && id === this.twoSidedVariantId ? this.twoSidedValue || '' : '';
        if (value) event.formData.set('properties[Two-sided cards]', value);
        else event.formData.delete('properties[Two-sided cards]');
      };
      this.onVersion = event => {
        if (this.dataset.versionedPremade === 'true' && String(event.detail?.variantId) === this.selectedVariantId) this.applyVersion(event.detail);
      };
      this.onToggle = () => {
        const previousHeight = this.viewport.getBoundingClientRect().height;
        const previousY = window.scrollY;
        this.expanded = !this.expanded;
        this.measure();
        if (!this.expanded) window.scrollTo({ top: Math.max(0, previousY - previousHeight + this.viewport.getBoundingClientRect().height), behavior: 'instant' });
      };
      this.toggle.addEventListener('click', this.onToggle);
      document.addEventListener('variant:changed', this.onVariant);
      document.addEventListener('formdata', this.onFormData, true);
      document.addEventListener('trc:premade-version', this.onVersion);
      this.onVariant();
      if (this.dataset.uploadInput) {
        this.fileInput = this.closest('form')?.querySelector('[id="' + this.dataset.uploadInput + '"]');
        this.onFile = () => {
          const generation = ++this.generation;
          this.clearThumbnailRetries();
          this.observer?.disconnect();
          this.grid.replaceChildren();
          this.hidden = true;
          this.expanded = false;
          const file = this.fileInput?.files?.[0];
          if (!file || file.size > 512 * 1024) return;
          this.start(generation, file);
        };
        this.fileInput?.addEventListener('change', this.onFile);
        this.onFile();
      } else if (this.dataset.versionedPremade !== 'true') this.start(this.generation);
    }
    resetVersion() {
      this.generation++;
      this.clearThumbnailRetries();
      clearTimeout(this.thumbnailRetry);
      this.thumbnails = null;
      this.observer?.disconnect();
      this.viewObserver?.disconnect();
      this.grid.replaceChildren();
      this.hidden = true; this.expanded = false;
      this.versionFingerprint = '';
      this.twoSided = 0;
      this.syncFoil();
    }
    // Premade products only (an uploaded XML is handled by the deck form): the foil line (under the grid, so
    // it shows with the preview and never without it), the product form's "Two-sided cards" property and,
    // when the theme setting asks for it, the confirmation.
    syncFoil() {
      if (this.dataset.uploadInput) return;
      const foil = this.dataset.foil === 'true';
      const count = foil && !this.hidden ? this.twoSided || 0 : 0;
      // The variant this value was counted for (the main form's), checked again on every cart request.
      // No main form id, no match: an empty id never lets a request carry the value.
      this.twoSidedVariantId = String(document.getElementById(`product-form-${this.dataset.sectionId}`)?.querySelector('[name=id]')?.value || '');
      this.twoSidedValue = twoSidedValue(count);
      // The main form's field and the sticky add-to-cart bar's copy carry the same value.
      const sticky = this.dataset.productId ? [...document.querySelectorAll(`sticky-atc-bar[data-product-id="${this.dataset.productId}"] [data-two-sided-field]`)] : [];
      for (const field of [this.querySelector('[data-two-sided-field]'), ...sticky]) {
        if (!field) continue;
        field.value = this.twoSidedValue;
        field.disabled = !field.value;
      }
      // While the confirmation is shown, Buy it now (which skips it) is hidden.
      const acknowledging = count > 0 && this.dataset.twoSidedAck === 'true';
      document.getElementById(`product-form-${this.dataset.sectionId}`)?.classList.toggle('trc-two-sided-ack-open', acknowledging);
      for (const field of sticky) field.form?.classList.toggle('trc-two-sided-ack-open', acknowledging);
      const note = this.querySelector('[data-premade-foil-note]');
      const key = foil ? `${count}|${acknowledging}` : '';
      if (!note || note.trcKey === key) return;
      note.trcKey = key;
      note.hidden = !foil;
      note.classList.toggle('has-two-sided', count > 0);
      // A new message always starts with the confirmation unchecked.
      // Only the sentence is a live region, never the confirmation checkbox beside it.
      const content = foil ? [Object.assign(document.createElement('p'), { role: 'status', textContent: foilNoteText(count) })] : [];
      if (acknowledging) {
        // Required on the product form itself, so the browser holds Add to cart until it is checked.
        const label = document.createElement('label');
        label.className = 'trc-premade-preview__ack';
        const check = document.createElement('input');
        check.type = 'checkbox';
        check.required = true;
        check.setAttribute('form', `product-form-${this.dataset.sectionId}`);
        check.setAttribute('data-two-sided-ack', '');
        label.append(check, Object.assign(document.createElement('span'), { textContent: 'I understand that foil prints on card fronts only.' }));
        content.push(label);
      }
      note.replaceChildren(...content);
    }
    applyVersion(data) {
      const xmlUrl = data.managed ? data.active?.previewXmlUrl || data.active?.decklistSnapshotUrl || '' : this.legacyXmlUrl;
      const thumbnailsUrl = data.managed && typeof data.active?.thumbnailsUrl === 'string' ? data.active.thumbnailsUrl : '';
      const fingerprint = `${this.selectedVariantId}:${xmlUrl}:${thumbnailsUrl}`;
      if (fingerprint === this.versionFingerprint) return;
      this.resetVersion();
      this.versionFingerprint = fingerprint;
      this.versionVariantId = this.selectedVariantId;
      this.dataset.xmlUrl = xmlUrl;
      this.thumbnails = thumbnailsUrl ? { url: thumbnailsUrl, variantId: this.selectedVariantId, revision: String(data.active?.revision || '') } : null;
      if (xmlUrl) this.start(this.generation);
    }
    async start(generation, file) {
      try {
        const thumbSource = this.thumbnails && !file ? this.thumbnails : null;
        const mapRequest = thumbSource ? loadThumbnails(thumbSource.url, thumbSource.variantId, thumbSource.revision) : null;
        const [parsed, map] = await Promise.all([
          file ? parse(await file.text(), 1000) : load(this.dataset.xmlUrl),
          mapRequest ? Promise.race([mapRequest, new Promise(resolve => setTimeout(() => resolve(null), THUMBNAIL_WAIT_MS))]) : null
        ]);
        if (!this.isConnected || generation !== this.generation) return;
        // Copies: tiles change their faces, and a premade's parse is shared (load caches it).
        // A slow map: Drive cards start as placeholders and the map fills them in.
        const cards = parsed.map(card => thumbSource ? withThumbnails(card, map ? map.thumbnails : {}) : { ...card });
        cards.twoSided = parsed.twoSided;
        // Drive faces a later map can still give an image (or a fallback).
        const mapFaces = [];
        const applyMap = thumbnails => {
          for (const { face, show } of mapFaces) {
            const url = Object.prototype.hasOwnProperty.call(thumbnails, face.driveId) ? firstPartyThumbnail(thumbnails[face.driveId]) : '';
            if (!url) continue;
            if (face.placeholder) { face.url = url; face.placeholder = false; show(); }
            else if (face.firstParty && !face.fallbackUrl) face.fallbackUrl = url;
          }
        };
        // S23: thumbnails (a premade often has 100 or more, and so can a customer's file) wait until the
        // preview is near the screen, and then only the rows the collapsed grid shows load; the rest load
        // with Show more. A customer's file is usually on screen already, so its rows show at once.
        const deferred = typeof IntersectionObserver === 'function';
        this.twoSided = cards.twoSided || 0;
        // Reference XMLs intentionally omit private local images such as the
        // generated deck spotlight and info-card back. Those are not errors.
        let missing = cards.filter(c => !c.url && !c.placeholder && (file || !c.localOnly)).length;
        const updateNote = () => {
          const note = this.querySelector('[data-note]');
          note.hidden = !missing;
          // D1-3: the customer's own file may name Drive images that are gone; say so plainly.
          note.textContent = file
            ? 'Some images in your file did not load here yet. Try again in a minute. If they still do not show, they may be deleted or private on Google Drive. We check every image before we print and contact you if one cannot be printed.'
            : 'Some preview images are unavailable. This deck’s printed artwork is fixed.';
        };
        // One tile per slot: a back entry (flagged back, right after its front) is the other side of that front's tile,
        // shown with the flip button, never a tile of its own.
        const tiles = [];
        for (const card of cards) {
          const last = tiles[tiles.length - 1];
          if (!card.back) { if (card.url || card.placeholder) tiles.push({ card, back: null }); }
          else if (last && last.card.slot === card.slot && !last.back && (card.url || card.placeholder)) last.back = card;
        }
        for (const entry of tiles) {
          const { card } = entry;
          const tile = document.createElement('div');
          tile.className = 'trc-premade-preview__card';
          tile.title = card.name;
          const img = document.createElement('img');
          img.loading = 'lazy'; img.decoding = 'async';
          // A face without a usable thumbnail: its name, in a tile of the same size.
          const placeholder = document.createElement('span');
          placeholder.className = 'trc-premade-preview__placeholder';
          placeholder.hidden = true;
          // The URL each face shows: its own, or its one fallback once that was needed.
          const source = new Map();
          let showBack = false; let flip = null; let tag = null;
          const show = () => {
            const face = showBack ? entry.back : card;
            tile.classList.toggle('is-scryfall', !!face.scryfall);
            // A back face never wears the foil sheen; on a foil deck it says so (CSS shows the tag).
            tile.classList.toggle('is-back', showBack);
            img.alt = showBack ? `Back of ${card.name}` : card.name;
            placeholder.hidden = !face.placeholder;
            img.hidden = !!face.placeholder;
            tile.classList.toggle('is-placeholder', !!face.placeholder);
            if (face.placeholder) {
              placeholder.textContent = img.alt;
              this.clearSource(img);
            } else {
              const url = source.get(face) || face.url;
              if (!deferred || tile.trcLive) this.setSource(img, url);
              else img.dataset.src = url;
            }
            if (showBack && !tag) img.after(tag = Object.assign(document.createElement('span'), { className: 'trc-premade-preview__nofoil', textContent: 'Not foil' }));
            else if (!showBack && tag) { tag.remove(); tag = null; }
            flip?.setAttribute('aria-pressed', String(showBack));
          };
          img.addEventListener('error', () => {
            if (generation !== this.generation) return;
            const face = showBack ? entry.back : card;
            // One bounded retry of the same selected art, never another printing.
            if (face.fallbackUrl && !source.has(face)) {
              source.set(face, face.fallbackUrl);
              this.setSource(img, face.fallbackUrl);
              return;
            }
            if (!tile.isConnected) return;
            // With a thumbnail map, a failed image keeps its tile as a placeholder.
            if (thumbSource && face.driveId) { face.placeholder = true; face.url = ''; show(); return; }
            // A card whose copy did not load (busy, or not fetched yet) keeps its tile with the card's name
            // and is asked for again later, ahead of tiles still waiting; only when every try fails does
            // the note say so.
            if (face.driveId && isXmlThumbnail(source.get(face) || face.url)) {
              face.placeholder = true;
              show();
              const tries = face.thumbnailTries = (face.thumbnailTries || 0) + 1;
              if (tries > XML_THUMBNAIL_RETRY_MS.length) { missing++; updateNote(); return; }
              this.thumbnailRetries.push(setTimeout(() => {
                if (generation !== this.generation || !tile.isConnected) return;
                face.placeholder = false;
                source.set(face, xmlThumbnailUrl(face.driveId, tries));
                img.trcFirst = true;
                show();
                delete img.trcFirst;
              }, XML_THUMBNAIL_RETRY_MS[tries - 1]));
              return;
            }
            missing++; updateNote();
            if (showBack) {
              // The back cannot show: the tile goes back to its front and keeps no flip.
              flip.remove(); flip = null; entry.back = null; showBack = false; show();
              return;
            }
            tile.remove(); this.measure();
            if (!this.grid.children.length && !file) { this.hidden = true; this.syncFoil(); }
          });
          tile.append(img, placeholder);
          if (thumbSource) for (const face of [card, entry.back]) if (face && face.driveId) mapFaces.push({ face, show });
          if (entry.back) {
            flip = Object.assign(document.createElement('button'), { type: 'button', className: 'trc-premade-preview__flip', innerHTML: FLIP_ICON });
            flip.setAttribute('aria-label', `Flip ${card.name}`);
            flip.addEventListener('click', () => { tile.trcLive = true; showBack = !showBack; show(); });
            tile.append(flip);
          }
          show();
          this.grid.append(tile);
        }
        if (!this.grid.children.length && !file) return;
        this.hidden = false;
        updateNote();
        if (thumbSource && mapFaces.length) {
          const retryIfUnfinished = current => {
            if (current.complete) return;
            clearTimeout(this.thumbnailRetry);
            this.thumbnailRetry = setTimeout(async () => {
              const next = await loadThumbnails(thumbSource.url, thumbSource.variantId, thumbSource.revision, true);
              if (this.isConnected && generation === this.generation) applyMap(next.thumbnails);
            }, THUMBNAIL_RETRY_MS);
          };
          if (map) retryIfUnfinished(map);
          else mapRequest.then(late => {
            if (!this.isConnected || generation !== this.generation) return;
            applyMap(late.thumbnails);
            retryIfUnfinished(late);
          });
        }
        this.syncFoil();
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.grid);
        if (deferred && !this.inView) {
          this.viewObserver?.disconnect();
          this.viewObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.inView = true;
            this.viewObserver.disconnect();
            this.reveal();
          }, { rootMargin: '600px 0px' });
          this.viewObserver.observe(this);
        }
        this.measure();
      } catch (error) {
        if (generation !== this.generation) return;
        // A merchant's missing/invalid file must never interrupt purchasing.
        this.hidden = true;
        this.twoSided = 0;
        this.syncFoil();
        if (window.Shopify?.designMode) console.warn('Premade deck preview:', error.message);
      }
    }
    measure() {
      const rows = [];
      for (const card of this.grid.children) {
        const rect = card.getBoundingClientRect();
        if (rect.height && !rows.some(row => Math.abs(row.top - rect.top) < 2)) rows.push(rect);
      }
      const collapsible = rows.length > 3;
      // The tiles the collapsed grid shows: its first four rows (the fourth fades out).
      this.collapsedCount = collapsible
        ? [...this.grid.children].filter(card => card.getBoundingClientRect().top < rows[3].top + rows[3].height).length
        : this.grid.children.length;
      this.viewport.classList.toggle('is-collapsible', collapsible);
      this.viewport.classList.toggle('is-expanded', this.expanded);
      this.toggle.hidden = !collapsible;
      this.toggle.setAttribute('aria-expanded', String(this.expanded));
      this.querySelector('[data-toggle-label]').textContent = this.expanded ? 'Show less' : 'Show more';
      if (collapsible) {
        this.viewport.style.setProperty('--collapsed-height', `${Math.ceil(rows[3].top - rows[0].top + rows[3].height / 2)}px`);
        this.viewport.style.setProperty('--fade-height', `${Math.ceil(rows[3].height / 2)}px`);
      }
      this.reveal();
    }
    // Loads the deferred thumbnails the customer can see: once the preview is near the screen, the
    // collapsed rows; every tile once expanded.
    reveal() {
      if (!this.inView && !this.expanded) return;
      const tiles = [...this.grid.children];
      const limit = this.expanded ? tiles.length : this.collapsedCount ?? tiles.length;
      for (const tile of tiles.slice(0, limit)) {
        tile.trcLive = true;
        const img = tile.querySelector('img');
        if (img?.dataset.src) { const url = img.dataset.src; delete img.dataset.src; this.setSource(img, url); }
      }
    }
    // Sets an image's source. Copies of MPC Fill art wait their turn: at most MAX_XML_THUMBNAIL_LOADS
    // load at once (each slot frees when its image loads or fails, or when the image changes).
    // A retry (img.trcFirst) goes to the front of the queue.
    setSource(img, url) {
      this.dequeue(img);
      if (!isXmlThumbnail(url)) { img.src = url; return; }
      this.thumbnailQueue[img.trcFirst ? 'unshift' : 'push']({ img, url, generation: this.generation });
      this.pumpThumbnails();
    }
    clearSource(img) {
      this.dequeue(img);
      img.removeAttribute('src'); delete img.dataset.src;
    }
    dequeue(img) {
      img.trcSettle?.();
      this.thumbnailQueue = (this.thumbnailQueue || []).filter(entry => entry.img !== img);
    }
    pumpThumbnails() {
      if (this.thumbnailGeneration !== this.generation) { this.thumbnailGeneration = this.generation; this.thumbnailLoads = 0; }
      while (this.thumbnailLoads < MAX_XML_THUMBNAIL_LOADS && this.thumbnailQueue.length) {
        const { img, url, generation } = this.thumbnailQueue.shift();
        if (generation !== this.generation) continue;
        this.thumbnailLoads++;
        let done = false;
        let turn = 0;
        const settle = () => {
          if (done) return;
          done = true;
          clearTimeout(turn);
          img.removeEventListener('load', settle); img.removeEventListener('error', settle);
          if (img.trcSettle === settle) delete img.trcSettle;
          if (this.thumbnailGeneration !== generation) return;
          this.thumbnailLoads = Math.max(0, this.thumbnailLoads - 1);
          this.pumpThumbnails();
        };
        img.trcSettle = settle;
        img.addEventListener('load', settle); img.addEventListener('error', settle);
        turn = setTimeout(settle, XML_THUMBNAIL_TURN_MS);
        img.src = url;
      }
    }
    clearThumbnailRetries() {
      for (const timer of this.thumbnailRetries || []) clearTimeout(timer);
      this.thumbnailRetries = [];
      this.thumbnailQueue = [];
    }
    disconnectedCallback() {
      clearTimeout(this.thumbnailRetry);
      this.clearThumbnailRetries();
      document.removeEventListener('formdata', this.onFormData, true);
      this.generation = (this.generation || 0) + 1;
      this.observer?.disconnect();
      this.viewObserver?.disconnect();
      document.removeEventListener('variant:changed', this.onVariant);
      document.removeEventListener('trc:premade-version', this.onVersion);
      this.toggle?.removeEventListener('click', this.onToggle);
      this.fileInput?.removeEventListener('change', this.onFile);
      this.initialized = false;
      this.grid?.replaceChildren();
    }
  }
  customElements.define('trc-premade-preview', PremadePreview);
})();
